var _path, _line, _path2, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWithdrawal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5173 23.9198C20.9465 23.6266 21.0567 23.0409 20.7634 22.6118C20.4702 22.1826 19.8845 22.0724 19.4554 22.3657L20.5173 23.9198ZM14.8024 24.6099L14.8474 23.6698L14.8474 23.6698L14.8024 24.6099ZM9.78234 22.6543L9.17955 23.3771L9.17955 23.3771L9.78234 22.6543ZM6.95687 18.0671L6.04015 18.2802L6.95687 18.0671ZM11.1116 8.73445L10.6565 7.91061L10.6565 7.91061L11.1116 8.73445ZM16.4111 7.76435L16.2774 8.69597L16.4111 7.76435ZM21.2236 10.1861L21.8921 9.52356L21.8921 9.52355L21.2236 10.1861ZM22.6697 15.1455C22.7389 15.6606 23.2127 16.0221 23.7279 15.9528C24.243 15.8835 24.6045 15.4097 24.5352 14.8946L22.6697 15.1455ZM19.4554 22.3657C18.1022 23.2903 16.4844 23.7481 14.8474 23.6698L14.7574 25.55C16.8036 25.6479 18.8259 25.0756 20.5173 23.9198L19.4554 22.3657ZM14.8474 23.6698C13.2105 23.5914 11.6437 22.9811 10.3851 21.9315L9.17955 23.3771C10.7528 24.6891 12.7112 25.452 14.7574 25.55L14.8474 23.6698ZM10.3851 21.9315C9.12651 20.8819 8.24471 19.4503 7.8736 17.854L6.04015 18.2802C6.50404 20.2756 7.60628 22.0651 9.17955 23.3771L10.3851 21.9315ZM7.8736 17.854C7.50249 16.2577 7.66233 14.5839 8.32885 13.0868L6.60921 12.3212C5.77605 14.1927 5.57626 16.2849 6.04015 18.2802L7.8736 17.854ZM8.32885 13.0868C8.99537 11.5896 10.1322 10.3507 11.5667 9.55829L10.6565 7.91061C8.86337 8.90116 7.44236 10.4497 6.60921 12.3212L8.32885 13.0868ZM11.5667 9.55829C13.0012 8.76585 14.6551 8.46309 16.2774 8.69597L16.5448 6.83272C14.5171 6.54162 12.4497 6.92007 10.6565 7.91061L11.5667 9.55829ZM16.2774 8.69597C17.8996 8.92885 19.4015 9.68465 20.5552 10.8486L21.8921 9.52355C20.45 8.06857 18.5726 7.12382 16.5448 6.83272L16.2774 8.69597ZM20.5552 10.8486C21.7088 12.0126 22.4512 13.5212 22.6697 15.1455L24.5352 14.8946C24.2622 12.8643 23.3342 10.9785 21.8921 9.52356L20.5552 10.8486Z",
    fill: "#DF3030"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.4426,
    y1: 16.1489,
    x2: 18.972,
    y2: 16.1489,
    stroke: "#F1A7A7",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0782 21.8784L26.8578 20.4764C27.4797 19.9865 27.4867 19.0463 26.8721 18.5472L25.0782 17.0901",
    stroke: "#E44E4E",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.9,
    x1: 0.941176,
    y1: -0.941176,
    x2: 4.70588,
    y2: -0.941176,
    transform: "matrix(-1 4.37114e-08 4.37114e-08 1 24.6195 20.3528)",
    stroke: "#F1A7A7",
    strokeWidth: 1.88235,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawal);
export default __webpack_public_path__ + "static/media/withdrawal.8d46f7277b2e6de933f46729e8a5fe13.svg";
export { ForwardRef as ReactComponent };